import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";

import ConfirmEmailForm from "modules/auth/confirm-email-form";
import Actions from "modules/auth/auth-actions";

class ConfirmEmailPage extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    email: PropTypes.string,
    onResendCode: PropTypes.func.isRequired,
    onChangeEmail: PropTypes.func.isRequired
  };

  render() {
    const { onSubmit, email, onResendCode, onChangeEmail } = this.props;
    return (
      <Fragment>
        <h2 className="sub-heading">
          <FormattedMessage id="sign-up.confirm-email.header" />
        </h2>
        <ConfirmEmailForm
          onSubmit={onSubmit}
          onResendCode={onResendCode}
          initialValues={{ email }}
          onChangeEmail={onChangeEmail}
        />
      </Fragment>
    );
  }
}

const mapDispatchToProps = {
  onSubmit: Actions.Creators.emailConfirmed,
  onResendCode: Actions.Creators.resendEmailCode
};

export default connect(
  null,
  mapDispatchToProps
)(ConfirmEmailPage);



// WEBPACK FOOTER //
// ./src/modules/auth/confirm-email-page.js